<template>
  <div>
    <section id="headerbar">
      <button
        class="btn btn-collapse"
        id="sidebarCollapse"
        v-on:click="toggle"
      ><i class="lnr lnr-menu"></i></button>
      <div class="dropdown box-lang">
        <b-dropdown
          variant="link"
          size="lg"
        >
          <template slot="button-content">
            {{$t("header.language")}}
          </template>
          <b-dropdown-item
            @click="changeLanguage('en')"
            href="#"
          >{{$t('header.lblEnglish')}}</b-dropdown-item>
          <b-dropdown-item
            @click="changeLanguage('mr')"
            href="#"
          >{{$t('header.lblMarathi')}}</b-dropdown-item>
          <b-dropdown-item
            @click="changeLanguage('hi')"
            href="#"
          >{{$t('header.lblHindi')}}</b-dropdown-item>
        </b-dropdown>

      </div>
      <form class="form-search">
      </form>
      <div class="box-profile-mini">
        <b-dropdown
          variant="link"
          size="lg"
        >
          <template slot="button-content">
            <div
              class="profile-img"
              v-if="this.$store.getters.getHeaderData.profile===null||this.$store.getters.getHeaderData.profile===undefined || this.$store.getters.getHeaderData.profile.photoUrl===''"
            > <img
                src="assets/images/user.png"
                alt=""
              ></div>
            <div
              class="profile-img"
              v-else
            ><img
                :src="this.$store.getters.getHeaderData.profile.photoUrl"
                alt=""
              ></div>
            <div
              class="profile-details"
              v-if="!this.$store.getters.getHeaderData.profile"
            >
              <div class="pname">{{$t("header.firstName")}}</div>
              <div class="ptext">{{$t("header.companyName")}}</div>
            </div>
            <div
              class="profile-details"
              v-if="this.$store.getters.getHeaderData.profile"
            >
              <div class="pname">{{this.$store.getters.getHeaderData.profile.personalDetails.fullName}}</div>
              <div class="ptext">{{this.$store.getters.getHeaderData.industryPartner.industryPartnerName}}</div>
            </div>
          </template>
          <b-dropdown-item @click="redirectToResetPassword()">{{$t("header.lblChangePassword")}}</b-dropdown-item>
          <!--   <b-dropdown-item href="#">{{$t("header.editProfile")}}</b-dropdown-item> -->
          <!--  <b-dropdown-item @click="logout">{{$t("header.logout")}}</b-dropdown-item> -->
        </b-dropdown>
        <!--  -->
      </div>
      <div class="box-icons">
        <!-- <a href="#"><i class="lnr lnr-alarm"></i></a>
                    <a href="#"><i class="lnr lnr-envelope"></i></a> -->
        <a @click="logout"><i class="lnr lnr-power-switch"></i></a>
      </div>
    </section>

  </div>
</template>
<script>
// import axios from 'axios'
// import lodashOrderBy from 'lodash/orderBy'
import MQL from "@/plugins/mql.js";
import * as types from "../store/types";

export default {
  name: "header1",
  data() {
    return {
      isActive: false,
      isOpen: false,
      isOpen2: false,
      headerData: null,

    };
  },
  created() {
    // if (sessionStorage.getItem('user-token') === null || sessionStorage.getItem('user-token') === "" || sessionStorage.getItem('user-token') === undefined) {
    //   this.$router.push("login")
    // }
    this.headerData = this.$store.getters.getHeaderData
    // console.log("jijijijiji", this.headerData)
    // this.GetProfileDetails();

  },
  methods: {
    redirectToResetPassword() {

      this.$router.push({        name: 'changePassword',
        path: "/changePassword"      })
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang
      this.loadMessagesFromFile()
    },
    loadMessagesFromFile() {
      return new Promise((resolve, reject) => {
        return import(`@/lang/${this.$i18n.locale}.json`).then(res => {
          this.$i18n.setLocaleMessage(this.$i18n.locale, res.default)
          resolve(true)
        })
      })
    },

    logout() {
      /* let vm = this;
      window.MKCLAPI.logout()
        .then(() => {
          vm.$store.dispatch("clearStore");
          vm.$router.push("/");
        })
        .catch(e => {
          vm.$toasted.error(vm.$t("logOut.failToLogout"));
        }); */
      this.$store
        .dispatch("AUTH_LOGOUT", {
          // loginType: "mfs_ip"
        })
        .then(res => { })
        .catch(err => {
          alert(err);
          Vue.$log.error(err);
        });
    },
    toggle: function () {
      var element = document.getElementById("left-sidebar");
      element.classList.toggle("active");
      var element2 = document.getElementById("main-content");
      element2.classList.toggle("active");

      // alert("fds");
      // `this` inside methods points to the Vue instance
      // var element = document.getElementById('nav1')
      // var element2 = document.getElementById('toggle-btn')
      // element.classList.toggle('shrinked')
      // `event` is the native DOM event
    },

    toggle2: function () {
      this.isOpen2 = !this.isOpen2;
    },
    search: function () {
      this.isActive = true;
    },
    searchclose: function () {
      this.isActive = false;
    },
    GetProfileDetails() {
      let vm = this
      // this.headerData = this.$store.getters.getHeaderData

      /*    new MQL()
           .setActivity("r.[query_1H26ksGAs7IUTlpuMBfVS4mYNga]")
           .fetch()
           .then(rs => {
             let res = rs.getActivity("query_1H26ksGAs7IUTlpuMBfVS4mYNga", true);
             res = res[0];
             if (res == null || res == "") {
              //  console.log("NO CANDIDATE DATA FOUND");
               console.error("NO DATA FOUND");
             }
             // vm.admissionData = res.admission;
             vm.$store.commit(types.GET_HEADER_SIDEBAR_DATA, res);
             this.headerData = this.$store.getters.getHeaderData
    */
      // this.candidateProfile = res[0];
      // this.learningData = res.learningData;
      // if (vm.admissionData.averageRating !== null && vm.admissionData.averageRating !== undefined && vm.admissionData.averageRating !== null) {
      // this.averageRatingScore = vm.admissionData.averageRating;
      // } else
      // this.averageRatingScore = 0
      // this.candidateSessionEndExamData =
      // res.learningData.learningInfo.learningScoreDetails;
      // if (rs.isValid("query_1H26ksGAs7IUTlpuMBfVS4mYNga")) {
      // } else {
      // rs.showErrorToast("query_1H26ksGAs7IUTlpuMBfVS4mYNga");
      // }
      // });
      // this.$MQLFetch("r.CandidateBriefProfile")
      //   .then(response => {
      //     var res = JSON.parse(JSON.stringify(response.result));
      //     this.headerData = res;
      //     //console.log(this.headerData);
      //   })
      //   .catch(err => {
      //     vm.$toasted.error("Error While Fetching Candidate Profiles")
      //     // console.log(err);
      //   });
    }
  }
};
</script>

<style scoped>
</style>
